module.exports = {"sm":"640px","md":"768px","lg":"1024px","xl":"1280px"}


//////////////////
// WEBPACK FOOTER
// ./src/lib/v-calendar/utils/defaults/screens.json
// module id = W9sE
// module chunks = 1